import React, { useState, useEffect } from "react";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "./ui/dialog";
import { Skeleton } from "../components/ui/skeleton";
import { Button } from "./ui/button";
import { ChevronDown, X } from "lucide-react";
import { InvestmentCarousel } from "./InvestmentCarousel";
import coin from "../assets/images/placeholder/crypto-colour.png";
import { SearchIcon } from "lucide-react";
import InvestProducts from "./InvestProducts";
import InvestProperty from "./InvestProperty";
import { useAvailableBalances } from "../hooks/query/queries";
import CurrencyFormatter from "../utils/currencyFormatter";
import { formatFiatWithTwoDecimals } from "../utils/numberFormatter";
export default function InvestExplore({ userId }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermAsset, setSearchTermAsset] = useState("");
  const [open, setOpen] = useState(false);
  const [productId, setProductId] = useState(null);
  const [productShow, setProductShow] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const { data: assetsOwned, isLoading } = useAvailableBalances(userId);
  const OPTIONS = {};
  const SLIDE_COUNT = 5;
  const SLIDES = Array.from(Array(SLIDE_COUNT).keys());

  const filteredAssets = assetsOwned?.filter(
    (assets) =>
      assets?.asset?.toLowerCase().includes(searchTermAsset?.toLowerCase()) ||
      assets?.assetName?.toLowerCase().includes(searchTermAsset?.toLowerCase())
  );
  useEffect(() => {
    if (!assetsOwned) return;

    const zarAsset = assetsOwned.find((asset) => asset.asset === "zar");
    if (zarAsset) {
      setSelectedAsset(zarAsset);
    }
  }, [assetsOwned]);

  const formatter = new CurrencyFormatter();
  const showProduct = (id) => {
    setProductId(id);
    setProductShow(true);
  };
  const handleSelect = (asset) => {
    setSelectedAsset(asset);
    setOpen(false);
  };
  const handleBack = () => {
    setProductShow(false);
  };
  return (
    <div className="col-span-4 px-8">
      <Card className="bg-white rounded-2xl shadow-sm py-3 mb-4">
        <CardHeader className="mb-4  px-6 ">
          <CardTitle className="text-[20px] font-semibold text-text-secondary">
            Available to invest
          </CardTitle>
        </CardHeader>
        <CardContent className="px-6 pb-6 outline outline-gray-50 rounded-lg outline-1 grid grid-cols-4 gap-4 grid-rows-1">
          <div className="space-y-2 col-span-1">
            <label className="text-gray-600 text-sm">Select asset</label>
            <Dialog open={open} onOpenChange={setOpen}>
              <DialogTrigger asChild>
                {isLoading ? (
                  <div className="w-full flex items-center justify-between py-4  px-4 rounded-2xl border border-gray-300 bg-muted/50">
                    <div className="flex items-center gap-3 ">
                      <Skeleton className="w-10 h-10 rounded-full bg-gray-300" />

                      <div className="flex flex-col gap-1">
                        <Skeleton className="w-10 h-5 rounded-full bg-gray-300" />
                      </div>
                    </div>
                    <Skeleton className="w-6 h-6 rounded-full bg-gray-300" />
                  </div>
                ) : (
                  <Button
                    variant="outline"
                    className="w-full flex items-center justify-between py-8 rounded-2xl hover:border-brand-primary transition-colors"
                  >
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10  rounded-full flex items-center justify-center">
                        {selectedAsset ? (
                          <img
                            src={selectedAsset?.assetIcon}
                            alt={selectedAsset?.assetName}
                            width={32}
                            height={32}
                            className="text-white"
                          />
                        ) : (
                          <img
                            src={coin}
                            alt={"Default Asset"}
                            width={32}
                            height={32}
                            className="text-white"
                          />
                        )}
                      </div>
                      <div className="text-left">
                        <div className="font-semibold">
                          {selectedAsset?.asset.toUpperCase()}
                        </div>
                      </div>
                    </div>
                    <ChevronDown className="text-gray-400" />
                  </Button>
                )}
              </DialogTrigger>

              <DialogContent className="max-w-sm rounded-2xl p-6">
                <DialogClose asChild>
                  <Button
                    variant="ghost"
                    onClick={() => setOpen(false)}
                    className="w-10 h-10 absolute top-4 right-4 text-gray-400 hover:text-gray-600 rounded-full p-0 flex items-center justify-center border border-gray-200 hover:bg-gray-100"
                  >
                    <X size={18} className="text-gray-700" />
                  </Button>
                </DialogClose>

                <DialogHeader>
                  <DialogTitle className="text-lg font-semibold text-gray-800">
                    Select an Asset
                  </DialogTitle>
                </DialogHeader>
                <div className="mt-4">
                  <input
                    type="text"
                    placeholder="Search addresses..."
                    className="w-full border rounded-lg px-3 py-2"
                    value={searchTermAsset}
                    onChange={(e) => setSearchTermAsset(e.target.value)}
                  />
                </div>
                <div className="mt-4 flex flex-col space-y-3 max-h-72 overflow-y-auto">
                  {assetsOwned &&
                    filteredAssets.map((asset) => {
                      return (
                        <button
                          key={asset.assetId}
                          onClick={() => {
                            handleSelect(asset);
                          }}
                          className="flex items-center gap-3 justify-between px-3 py-3 border rounded-lg border-transparent bg-gray-50 hover:border-rose-200"
                        >
                          <div className="flex items-center gap-3">
                            <img
                              src={asset.assetIcon}
                              alt={asset.assetName}
                              className="w-6 h-6"
                            />
                            <div className="flex flex-col text-left">
                              <span>{asset.assetName}</span>
                              <span className="text-xs text-gray-500">
                                {asset.asset?.toUpperCase()}
                              </span>
                            </div>
                          </div>
                          <div className="flex flex-col text-right">
                            <span className="font-bold">
                              {formatter.format(
                                asset.availableAmount,
                                asset.asset?.toUpperCase()
                              )}
                            </span>
                            <span className="text-xs text-gray-500">
                              {asset.valueInLocalCurrency
                                ? formatFiatWithTwoDecimals(
                                    asset.valueInLocalCurrency
                                  )
                                : "R 0.00"}
                            </span>
                          </div>
                        </button>
                      );
                    })}
                </div>
              </DialogContent>
            </Dialog>
          </div>
          <div className="space-y-2 col-span-3">
            <label className="text-gray-600 text-sm">
              Digital Wallet balance
            </label>
            <div className="p-5 rounded-2xl bg-gray-50 flex-1 flex items-center">
              <div className="text-xl font-semibold text-gray-600">
                {selectedAsset?.availableAmountFormatted}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
      {!productShow && (
        <div className="">
          <div className="flex justify-between items-center py-3 mb-2">
            <div className=" text-text-secondary text-[20px] font-semibold">
              Explore products
            </div>
            <div>
              <div className=" relative w-[400px]">
                <input
                  type="text"
                  placeholder="Search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="border-none rounded-3xl text-sm p-3 w-full pl-10 focus:ring-2 focus:ring-purple-400 transition bg-bg-light-gray-2 text-[14px] font-normal"
                />
                <SearchIcon className="w-4 h-4 text-gray-500 absolute left-3 top-1/2 transform -translate-y-1/2" />
              </div>
            </div>
          </div>
          <div>
            <InvestmentCarousel
              slides={SLIDES}
              options={OPTIONS}
              navClass="carousel-one"
            />
          </div>
          <div className="mt-4">
            <InvestProducts onView={showProduct} searchTerm={searchTerm} />
          </div>
        </div>
      )}

      {productShow && (
        <div className="">
          <div className="mb-4">
            <InvestProperty productId={productId} onBack={handleBack} />
          </div>
          {/* <div>
            <InvestFaq />
          </div> */}
        </div>
      )}
    </div>
  );
}
